import styled from 'styled-components/macro';

interface LoadingIconProps {
  size?: 'small' | 'large' | 'default';
}

const varients = {
  size: {
    small: '0.7rem',
    default: '0.9rem',
    large: '1.1rem',
  },
};

export const LoadingWrapper = styled.span<LoadingIconProps>`
  display: inline-block;
  animation: loadingCircle 1s linear infinite;

  svg {
    display: block;
    position: relative;
    fill: currentColor;
    height: ${({ size = 'default' }) => varients.size[size]};
    width: ${({ size = 'default' }) => varients.size[size]};
  }

  @keyframes loadingCircle {
    100% {
      transform: rotate(360deg);
    }
  }
`;
